











































import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import Modal from './update-special-discount.modal.vue';
import { i18n } from '@/i18n';
import { compass } from '@resclick/compass';

@Component({
  components: {
    Modal,
  },
})
export default class SpecialDiscountShell extends Mixins(TableMixin) {
  query = {
    filter: {},
    populate: [
      {
        path: 'order',
        select: ['orderNumber', 'customer'],
        populate: [{ path: 'customer', select: ['name', 'surname'] }],
      },
      { path: 'agent', select: ['name', 'surname'] },
    ],
    currency: i18n.locale,
  };

  filters = [
    { label: this.$i18n.t('GENERAL.VOUCHER'), type: 'number', fieldName: 'orderNumber' },
    {
      label: this.$i18n.t('GENERAL.PAYMENT_DATE'),
      type: 'date-range',
      value: { start: new Date(), end: new Date() },
      fieldName: 'discountDate',
    },
  ];

  columns = [
    {
      label: 'GENERAL.ORDER',
      name: 'orderNumber',
      sortable: true,
      field: (row: any) => row.order?.orderNumber,
    },
    {
      label: 'GENERAL.CUSTOMER',
      name: 'customer',
      sortable: true,
      field: (row: any) => `${row.order?.customer?.name || ''} ${row.order?.customer?.surname || ''}`,
    },
    {
      label: 'GENERAL.AGENT',
      name: 'agent',
      sortable: true,
      field: (row: any) => `${row.agent?.name || ''} ${row.agent?.surname || ''}`,
    },
    {
      label: 'GENERAL.BOOKING_DATE',
      name: 'bookingDate',
      sortable: true,
      field: (row: any) => row.order && this.$formatDate(row.order.bookingDate),
    },
    {
      label: 'GENERAL.PAYMENT_DATE',
      name: 'discountDate',
      sortable: true,
      field: (row: any) => row.discountDate && row.discountDate,
    },
    {
      label: 'GENERAL.AMOUNT',
      name: 'amount',
      sortable: true,
      field: (row: any) => `${row.amount.toFixed(2) || 0} ${row.currency || ''}`,
    },
    {
      label: 'GENERAL.ACTIONS',
      name: 'actions',
    },
    {
      label: 'GENERAL.DELETE',
      name: 'delete',
    },
  ];

  async deleteSpecialDiscount(id: string) {
    compass
      .do('payments', 'deleteSpecialDiscount', {
        params: {
          specialDiscountId: id,
        },
      })
      .then(() => this.$refs.table.refresh());
  }
}
